import { Button, Card, Radio, RadioGroupProps } from 'antd';
import { useState } from 'react';

export type RadioFilterDropdownProps = {
  defaultValue?: string;
  options: Array<{ label: string; value: string }>;
  onApplyFilter: (values: string) => void;
};

const RadioFilterDropdown = (props: RadioFilterDropdownProps) => {
  const { options, onApplyFilter, defaultValue } = props;
  const [value, setValue] = useState<string>(defaultValue || '');

  const onChange: RadioGroupProps['onChange'] = (e) => setValue(e.target.value);
  const onApply = () => onApplyFilter(value);
  const onReset = () => setValue('');

  return (
    <Card title="Select" size="small">
      <div className="max-h-[200px] overflow-y-auto">
        <Radio.Group value={value} onChange={onChange} className="flex flex-col" options={options} />
      </div>
      <div className="flex gap-2 mt-2">
        <Button onClick={onReset}>Clear</Button>
        <Button type="primary" onClick={onApply}>
          Apply
        </Button>
      </div>
    </Card>
  );
};

export default RadioFilterDropdown;
